import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

const convertSelectedToString = (selected) => {
  if( selected != null){
      let s = "";
      for(let i = 0; i < selected.length; i++){
        if( i != selected.length - 1)
          s += selected[i].value + ";"
        else
          s += selected[i].value;
      }
      return s;
  }
}

const convertStringToSelected = (stringSelected) => {
  let s = stringSelected.split(";");
  return s;
}

const selectAll = (options) => {
  let selected = [];
  for(let i = 0; i < options.length; i++){
     selected.push(options[i]);
  }
  return selected;
}

export function PIPWorkLossDriverSelector({attr, altAttr, additionalOptions, dataType, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];

  const drivers = applicationModel.getValue('drivers');

  let driverOptions = drivers ? drivers.filter(driver => {
    return driver.status === 'Active' && parseInt(driver.personInfo.age) >= 60;
  }).map(driver => {
      let nameVal = driver.nameInfo.surname.toUpperCase()+","+driver.nameInfo.givenName.toUpperCase();
      if(driver.nameInfo.otherGivenName)
        nameVal = nameVal+","+driver.nameInfo.otherGivenName.toUpperCase();
      if(driver.nameInfo.suffixCd)
        nameVal = nameVal+","+driver.nameInfo.suffixCd.toUpperCase();
        return ({
          value: `${nameVal}`,
          name: `${driver.nameInfo.surname}, ${driver.nameInfo.givenName} - ${driver.personInfo.birthDt}`
        })
  }) : [];

  let limitOptions = driverOptions;

  let children = limitOptions.map(({value, name}) => <PortalSelectOption value={value}>
          {name}
        </PortalSelectOption>);
  let options = React.Children.map(children, el => {
      if (!el.props) {
        return null;
      }
      const obj = {
        label: el.props.children,
        value: el.props.value
      };
      return obj;
  });

  let disabled = false;
  let clearable = false;

  if(dataType && dataType === 'SelectUpdate'){
    let selected = [];

    children = limitOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if(props.value != undefined) {
          let vals = convertStringToSelected(props.value);
          for(let i = 0; i < vals.length; i++){
              if (el.props.value === vals[i]) {
                selected.push(obj);
              }
          }
        }
        return obj;
    });

    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = formContext;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    const previousValue = selected;

    const handleChange = (selected) => {
      let stringSelected = convertSelectedToString(selected)
      setValueByAttr(attr, stringSelected);
      setSelectedValue(selected);
      actions.saveApplication();
    };

      return <Select
              {...props}
              isMulti
              isDisabled={disabled}
              isClearable={clearable}
              aria-label="Select"
              styles={customStylesUpdater}
              title="Select"
              openMenuOnFocus
              placeholder={null}
              options={options}
              value={selected}
              onChange={handleChange}
              components={{
                IndicatorSeparator: () => null,
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 4,
                zIndex: 3,
                colors: {
                  ...theme.colors,
                  primary25: 'rgb(0, 115, 157, 0.1)',
                  primary: 'rgba(0, 115, 157, 0.5)',
                  neutral30: 'rgba(0, 115, 157, 0.5)',
                },
              })}
            />
  }
  return <PortalSelect {...props}>
    {
      driverOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

PIPWorkLossDriverSelector.schema = BASIC_ELEMENT_SCHEMA;